import { useEffect } from "react";

const SITE_NAME = "cartonmove";
const SITE_URL = "https://cartonmove.fr";
const DEFAULT_OG_IMAGE =
  "https://wsrv.nl/?url=customer-assets.emergentagent.com/job_moving-supplies-idf/artifacts/if3extyn_ChatGPT%20Image%208%20juin%202026%2C%2019_13_08.png&w=1200&h=630&output=jpg&q=85&we&fit=cover";

const upsertMeta = (selector, attr, name, content) => {
  let m = document.head.querySelector(selector);
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute(attr, name);
    document.head.appendChild(m);
  }
  m.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let l = document.head.querySelector(`link[rel="${rel}"]`);
  if (!l) {
    l = document.createElement("link");
    l.setAttribute("rel", rel);
    document.head.appendChild(l);
  }
  l.setAttribute("href", href);
};

/**
 * Met à jour title, meta description, balises Open Graph et Twitter Cards.
 * Backward-compatible : (title) ou (title, description) suffisent.
 *
 * @param {string} title
 * @param {string} [description]
 * @param {object} [options]
 * @param {string} [options.image]       URL absolue de l'image OG (1200×630 idéal)
 * @param {"website"|"article"|"product"} [options.type="website"]
 * @param {string} [options.canonical]   URL canonique absolue (sinon dérivée de window.location.pathname)
 */
export const useDocumentTitle = (title, description, options = {}) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      upsertMeta('meta[name="description"]', "name", "description", description);
    }

    const { image, type = "website", canonical } = options;
    const ogImage = image || DEFAULT_OG_IMAGE;
    const url =
      canonical ||
      (typeof window !== "undefined"
        ? `${SITE_URL}${window.location.pathname}`
        : SITE_URL);

    // Canonical link
    upsertLink("canonical", url);

    // Open Graph (Facebook, LinkedIn, etc.)
    if (title) upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    if (description)
      upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    upsertMeta('meta[property="og:url"]', "property", "og:url", url);
    upsertMeta('meta[property="og:image"]', "property", "og:image", ogImage);
    upsertMeta('meta[property="og:type"]', "property", "og:type", type);
    upsertMeta('meta[property="og:site_name"]', "property", "og:site_name", SITE_NAME);
    upsertMeta('meta[property="og:locale"]', "property", "og:locale", "fr_FR");

    // Twitter Card
    upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    if (title) upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    if (description)
      upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", ogImage);
  }, [title, description, options.image, options.type, options.canonical]);
};
